import * as t from "./types";
import * as actions from "./action";

/* Global Message */
export const setGlobalMessageAction = (
  payload: t.SetGlobalMessageRequestType
): t.SetGlobalMessageActionType => {
  return {
    type: actions.SET_GLOBAL_MESSAGE,
    payload,
  };
};
